export const STEPS = {
  UNDER_18_INELIGIBLE: 'UNDER_18_INELIGIBLE',
  PROVIDER_ELIGIBILITY_ELIGIBLE: 'PROVIDER_ELIGIBILITY_ELIGIBLE',
  PROVIDER_ELIGIBILITY_INELIGIBLE: 'PROVIDER_ELIGIBILITY_INELIGIBLE',
  POLICY_PENDING: 'POLICY_PENDING',
  POLICY_CONFIRMED: 'POLICY_CONFIRMED',
  POLICY_INVALID: 'POLICY_INVALID',
  SERVICE_ELIGIBILITY_PENDING: 'SERVICE_ELIGIBILITY_PENDING',
  SERVICE_ELIGIBILITY_ELIGIBLE: 'SERVICE_ELIGIBILITY_ELIGIBLE',
  SERVICE_ELIGIBILITY_INELIGIBLE: 'SERVICE_ELIGIBILITY_INELIGIBLE',
  SERVICE_ELIGIBILITY_INEFFECTIVE: 'SERVICE_ELIGIBILITY_INEFFECTIVE',
  SERVICE_ELIGIBILITY_UNINSURED: 'SERVICE_ELIGIBILITY_UNINSURED',
  ERROR: 'ERROR',
}
